document.addEventListener("DOMContentLoaded", function () {
  var popup = document.getElementById("carwash-popup");
  var closeBtn = document.getElementById("popup-close-btn");
  var body = document.body;
  function checkScrollPosition() {
    var scrollPosition = window.scrollY;
    var pageHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrollPercentage = (scrollPosition / pageHeight) * 100;
    console.log("scrollPercentage", scrollPercentage);
    console.log("pageHeight", pageHeight);
    console.log("scrollPosition", scrollPosition);
    return scrollPercentage >= 50;
  }
  window.addEventListener("scroll", function () {
    if (
      checkScrollPosition() &&
      popup &&
      (!getCookie("Carwashpopup") || isCookieExpired("Carwashpopup"))
    ) {
      popup.style.display = "flex";
      body.classList.add("carwash-popup-jtpl");
    }
  });

  if (
    popup &&
    (!getCookie("Carwashpopup") || isCookieExpired("Carwashpopup"))
  ) {
    if (checkScrollPosition()) {
      popup.style.display = "flex";
      body.classList.add("carwash-popup-jtpl");
    }
  }

  closeBtn.addEventListener("click", function () {
    popup.style.display = "none";
    body.classList.remove("carwash-popup-jtpl");
    setCookie("Carwashpopup", "true", 1);
  });

  popup.addEventListener("click", function (event) {
    if (event.target === popup) {
      popup.style.display = "none";
      body.classList.remove("carwash-popup-jtpl");
      setCookie("Carwashpopup", "true", 1);
    }
  });
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }
  function setCookie(name, value, days = 1) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  function isCookieExpired(name) {
    var cookie = getCookie(name);
    if (cookie) {
      var cookieDate = new Date(cookie);
      var currentDate = new Date();
      var diffTime = currentDate - cookieDate;
      return diffTime >= 24 * 60 * 60 * 1000;
    }
    return true;
  }
});
